var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZettablockLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 50,
    viewBox: "0 0 161 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4497_29548)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 17.7179L0 25V13H12V17.7179Z",
    fill: "#263DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 17.7179L12 25V13H24V17.7179Z",
    fill: "#263DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 32.2821L24 25V37H12V32.2821Z",
    fill: "#263DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 32.2821L12 25V37H0V32.2821Z",
    fill: "#263DFF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 34.7597H46.1245V31.4753H36.6018V31.3685L45.9649 19.3258V16.0681H32.2394V19.3792H41.3897V19.486L32 31.5554V34.7597Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0465 35C57.6108 35 59.8718 32.9439 60.2442 30.4339H56.7596C56.4936 31.2884 55.6424 32.036 54.0465 32.036C51.9983 32.036 51.0407 30.7009 51.0141 28.8051H60.4304V27.4166C60.4304 23.6248 58.1162 20.6342 53.9933 20.6342C49.5511 20.6342 47.3699 23.8919 47.3699 27.8438C47.3699 31.8491 49.7639 35 54.0465 35ZM51.0407 26.4286C51.1205 24.8531 51.9983 23.6248 53.9933 23.6248C55.8552 23.6248 56.733 24.8531 56.7862 26.4286H51.0407Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0866 34.7597H70.6934V31.6355H69.0974C67.8738 31.6355 67.3152 31.0748 67.3152 29.7664V23.9186H70.6402V20.8745H67.3152V17.2163H63.8838V20.8745H61.4899V23.9186H63.7508V30.5407C63.7508 32.9973 65.0276 34.7597 68.0866 34.7597Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0167 34.7597H79.6235V31.6355H78.0275C76.8039 31.6355 76.2453 31.0748 76.2453 29.7664V23.9186H79.5703V20.8745H76.2453V17.2163H72.814V20.8745H70.42V23.9186H72.681V30.5407C72.681 32.9973 73.9578 34.7597 77.0167 34.7597Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0376 35C87.8198 35 89.1232 34.3324 89.8946 33.3178H90.001L90.267 34.7597H93.4324V25.5741C93.4324 22.7437 91.2778 20.6342 87.5538 20.6342C83.7767 20.6342 81.8083 22.7437 81.8083 25.3605H85.1598C85.1598 24.3725 85.9844 23.5714 87.474 23.5714C89.1764 23.5714 89.868 24.4793 89.868 25.6008V26.3752H86.7824C82.9255 26.3752 81.1965 28.1642 81.1965 30.6742C81.1965 33.1308 82.9521 35 86.0376 35ZM86.8888 32.1696C85.4524 32.1696 84.7343 31.4753 84.7343 30.514C84.7343 29.526 85.479 28.8585 87.0484 28.8585H89.868V29.6061C89.868 30.9947 88.7508 32.1696 86.8888 32.1696Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4145 34.7597H105.192C108.837 34.7597 111.124 32.7837 111.124 29.3658C111.124 26.8558 109.98 25.5474 108.491 24.8531V24.7463C109.555 24.1055 110.433 22.9573 110.433 20.9279C110.433 17.8571 108.172 16.0681 104.9 16.0681H96.4145V34.7597ZM100.032 23.518V19.2991H104.394C106.017 19.2991 106.735 20.1268 106.735 21.3551C106.735 22.6903 105.937 23.518 104.315 23.518H100.032ZM100.032 31.502V26.6689H104.634C106.602 26.6689 107.4 27.7904 107.4 29.0721C107.4 30.4873 106.549 31.502 104.634 31.502H100.032Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M113.177 34.7597H116.741V15H113.177V34.7597Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M125.232 35C129.674 35 131.935 31.9292 131.935 27.8438C131.935 23.7316 129.621 20.6342 125.232 20.6342C120.816 20.6342 118.502 23.7316 118.502 27.8438C118.502 31.9559 120.763 35 125.232 35ZM125.232 31.8491C123.237 31.8491 122.146 30.4873 122.146 27.8438C122.146 25.2003 123.21 23.785 125.232 23.785C127.227 23.785 128.317 25.1736 128.317 27.8438C128.317 30.4873 127.227 31.8491 125.232 31.8491Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M139.928 35C143.838 35 145.859 32.6502 146.072 29.526H142.481C142.322 30.9146 141.391 31.8491 139.848 31.8491C137.826 31.8491 136.816 30.4339 136.816 27.8171C136.816 25.227 137.826 23.785 139.848 23.785C141.364 23.785 142.322 24.7463 142.455 26.1615H146.046C145.859 23.0641 143.838 20.6342 139.848 20.6342C135.512 20.6342 133.171 23.5981 133.171 27.8171C133.171 32.0895 135.592 35 139.928 35Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M154.823 27.3097L160.409 21.1415V20.8745H156.259L151.445 26.2684V15H148.066V34.7597H151.445V28.4846L156.392 34.7597H160.675V34.4927L154.823 27.3097Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4497_29548"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZettablockLogo);
export default __webpack_public_path__ + "static/media/zettablock-logo.daa88ea161c7887a1d864aecfacd58e8.svg";
export { ForwardRef as ReactComponent };